module.exports = __webpack_public_path__ + "media/images/icons/illustration/upload-240ade9c76204af11372ccdd986212da.svg";